import React from 'react';
import './tools';

const DevToolsPanel = React.lazy(() => import('./DevToolsPanel'));

export default function DevTools() {
  if (!import.meta.env.DEV) return null;

  return (
    <React.Suspense fallback={null}>
      <DevToolsPanel />
    </React.Suspense>
  );
}

export { registerDevTool } from './registry';
